import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-transaction-loader-modal-shared",
  templateUrl: "./transaction-loader-modal-shared.component.html",
  styleUrls: ["./transaction-loader-modal-shared.component.scss"],
})
export class TransactionLoaderModalSharedComponent implements OnInit {
  @Input() currency: any;
  @Input() refundModalLoader: any;
  @Input() voidModalLoader: any;
  @Input() refundModalSuccess: any;
  @Input() voidModalSuccess: any;
  @Input() globalAmount: any;
  @Input() customRefundedS: any = false;
  constructor(public router:Router) {}

  ngOnInit(): void {}
  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.reloadComponent(true);
    // }, 1000);

  }
  reloadComponent(self:boolean,urlToNavigateTo ?:string){
    //skipLocationChange:true means dont update the url to / when navigating
   console.log("Current route I am on:",this.router.url);
   const url=self ? this.router.url :urlToNavigateTo;
   this.router.navigateByUrl('/',{skipLocationChange:true}).then(()=>{
     this.router.navigate([`/${url}`]).then(()=>{
       console.log(`After navigation I am on:${this.router.url}`)
     })
   })
 }
}
